import { z } from "zod";

export const systemMessages = z.enum([
  "log:ERROR",
  "log:WARNING",
  "action:BUILD",
  "log:COMPLETE",
  "set:ID",
  "set:NAME",
]);

export type SYSTEM_MESSAGE_TYPE = z.infer<typeof systemMessages>;

export type SYSTEM_MESSAGE = `__sys ${SYSTEM_MESSAGE_TYPE} ${string}`;

/**
 * These are for synchronising client and server state.
 * This should never be shown to the user.
 * @param type
 * @param value
 * @returns string formatted system message
 */
export function system_message(
  type: SYSTEM_MESSAGE_TYPE,
  value: string,
): SYSTEM_MESSAGE {
  if (value.includes(" "))
    throw new Error("System message values cannot contain spaces");
  return `__sys ${type} ${value}`;
}

export function isSystemMessage(message: string): message is SYSTEM_MESSAGE {
  return message?.length > 0 && message.startsWith("__sys");
}

export function parseSystemMessage(message: SYSTEM_MESSAGE): {
  type: SYSTEM_MESSAGE_TYPE;
  value: string;
} {
  const [_, type, value] = message.split(" ");
  return { type: type as SYSTEM_MESSAGE_TYPE, value };
}
